import { render, staticRenderFns } from "./FormLabRanap.vue?vue&type=template&id=4ed1aede&"
import script from "./FormLabRanap.vue?vue&type=script&lang=js&"
export * from "./FormLabRanap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports